module.exports = __webpack_public_path__ + "static/media/privacy.2378e43c.webp";